import { GameCard } from "./GameCard";
export default GameCard;
